import React, { useEffect, useState } from 'react';

import '../../styles/userTop.css'

/**
 * Componente que contiene los elementos relacionados al nombre de sesión
 * @param {Object} param0 Recibe un objeto con la información de la sesión y de la opción de menu activa
 * @returns Component Devuelve el componente con los elementos requeridos
 */
const UserTop = ({userLevel,setIsMostrarPacientes,isMostrarPacientes,setIsMostrarUsuarios,
    isMostrarUsuarios,setIsMostrarRecuperacion,isMostrarRecuperacion,totalQuirofano,totalRecuperacion}) => {

    //Estado que almacena se se debe mostrar la opción de logs
    const [isMostrarLogOption,setIsMostrarLogOption] = useState(false)
    //Estado que almacena si se debe mostrar el menu de navegación
    const [isMostrarMenu,setIsMostrarMenu] = useState(false)
    
    
    useEffect(()=>{
        if(userLevel === "superuser" || userLevel === "administrador"){//Se verifica si el usuario tiene permisos para asignación de usuarios
            setIsMostrarMenu(true)
            if(userLevel === "superuser"){//Se verifica si el usuario tiene acceso total
                setIsMostrarLogOption(true)
            }
            else{//Usuario con acceso de tipo administrador (no puede visualizar los logs)
                setIsMostrarLogOption(false)
            }
        }
        else{//Usuario con acceso restringuido
            setIsMostrarMenu(false)
            setIsMostrarLogOption(false)
        }

        switch(sessionStorage.getItem('active')){
            case 'pacientes':
                setIsMostrarPacientes(true)
                setIsMostrarUsuarios(false)
                setIsMostrarRecuperacion(false)
                break;
            case 'usuarios':
                setIsMostrarPacientes(false)
                setIsMostrarUsuarios(true)
                setIsMostrarRecuperacion(false)
                break
            case 'logs':
                setIsMostrarPacientes(false)
                setIsMostrarUsuarios(false)
                setIsMostrarRecuperacion(false)
                break
            case 'recuperacion':
                setIsMostrarPacientes(false)
                setIsMostrarUsuarios(false)
                setIsMostrarRecuperacion(true)
                break
            default:
                setIsMostrarPacientes(true)
                setIsMostrarUsuarios(false)
                setIsMostrarRecuperacion(false)
                break;
        }
    },[userLevel,setIsMostrarPacientes,setIsMostrarRecuperacion,setIsMostrarUsuarios])


    /**
     * Función que atrapa el evento click de la selección de menu
     * @param {Int16Array} opcion Recibe el número de opción seleccionado por el usuario
     * @returns Devuelve el estado del objeto
     */
    const handleMenuClick = (opcion) => (event) => {
        event.preventDefault()
        switch(opcion){
            case 1:
                sessionStorage.setItem('active','pacientes')
                setIsMostrarPacientes(true)
                setIsMostrarUsuarios(false)
                setIsMostrarRecuperacion(false)
                break
            case 2:
                sessionStorage.setItem('active','usuarios')
                setIsMostrarPacientes(false)
                setIsMostrarUsuarios(true)
                setIsMostrarRecuperacion(false)
                break
            case 3:
                sessionStorage.setItem('active','logs')
                setIsMostrarPacientes(false)
                setIsMostrarUsuarios(false)
                setIsMostrarRecuperacion(false)
                break
            case 4:
                sessionStorage.setItem('active','recuperacion')
                setIsMostrarPacientes(false)
                setIsMostrarUsuarios(false)
                setIsMostrarRecuperacion(true)
                break
            default:
                sessionStorage.setItem('active','pacientes')
                setIsMostrarPacientes(true)
                setIsMostrarUsuarios(false)
                setIsMostrarRecuperacion(false)
                break
                
        }
    }

    return (
        <>
        <div id="contenedorUserTop" className='contenedorUserTop'>
            {
                isMostrarMenu?(
                    <div className='menu_top'>
                        <div className='maxwidth'>
                            {
                                isMostrarPacientes
                                ?
                                    <> 
                                        {/* <div className='opc_menu' onClick={handleMenuClick(1)} style={{ color: '#0582a9' }}>Pacientes</div> */}
                                        <div className='opc_menuSeleccionada' onClick={handleMenuClick(1)} style={{ color: '#0582a9' }}>Quirófano ({totalQuirofano})</div>
                                        <div className='opc_menu' onClick={handleMenuClick(4)} style={{ color: '#282828' }}>Recuperación ({totalRecuperacion})</div>
                                        <div className='opc_menu' onClick={handleMenuClick(2)} style={{ color: '#282828' }}>Usuarios</div>
                                        {
                                            isMostrarLogOption ? <div className='opc_menu' onClick={handleMenuClick(3)} style={{ color: '#282828' }}>Bitacora</div>
                                            : <div className='opc_menu' onClick={handleMenuClick(3)} style={{ color: '#282828' }}>Bitacora</div>
                                        }
                                        
                                    </>
                                :
                                    isMostrarUsuarios
                                    ?
                                        <> 
                                            {/* <div className='opc_menu' onClick={handleMenuClick(1)} style={{ color: '#282828' }}>Pacientes</div> */}
                                            <div className='opc_menu' onClick={handleMenuClick(1)} style={{ color: '#282828' }}>Quirófano ({totalQuirofano})</div>
                                            <div className='opc_menu' onClick={handleMenuClick(4)} style={{ color: '#282828' }}>Recuperación ({totalRecuperacion})</div>
                                            <div className='opc_menuSeleccionada' onClick={handleMenuClick(2)} style={{ color: '#0582a9' }}>Usuarios</div>
                                            {
                                                isMostrarLogOption ? <div className='opc_menu' onClick={handleMenuClick(3)} style={{ color: '#282828' }}>Bitacora</div>
                                                : <div className='opc_menu' onClick={handleMenuClick(3)} style={{ color: '#282828' }}>Bitacora</div>
                                            }
                                        </>
                                    :
                                        isMostrarRecuperacion
                                        ?
                                            <> 
                                                {/* <div className='opc_menu' onClick={handleMenuClick(1)} style={{ color: '#282828' }}>Pacientes</div> */}
                                                <div className='opc_menu' onClick={handleMenuClick(1)} style={{ color: '#282828' }}>Quirófano ({totalQuirofano})</div>
                                                <div className='opc_menuSeleccionada' onClick={handleMenuClick(4)} style={{ color: '#0582a9' }}>Recuperación ({totalRecuperacion})</div>
                                                <div className='opc_menu' onClick={handleMenuClick(2)} style={{ color: '#282828' }}>Usuarios</div>
                                                {
                                                    isMostrarLogOption ? <div className='opc_menu' onClick={handleMenuClick(3)} style={{ color: '#282828' }}>Bitacora</div>
                                                    : <div className='opc_menu' onClick={handleMenuClick(3)} style={{ color: '#282828' }}>Bitacora</div>
                                                }
                                            </>
                                        :
                                            <> 
                                                {/* <div className='opc_menu' onClick={handleMenuClick(1)} style={{ color: '#282828' }}>Pacientes</div> */}
                                                <div className='opc_menu' onClick={handleMenuClick(1)} style={{ color: '#282828' }}>Quirófano ({totalQuirofano})</div>
                                                <div className='opc_menu' onClick={handleMenuClick(4)} style={{ color: '#282828' }}>Recuperación ({totalRecuperacion})</div>
                                                <div className='opc_menu' onClick={handleMenuClick(2)} style={{ color: '#282828' }}>Usuarios</div>
                                                {
                                                    isMostrarLogOption ? <div className='opc_menuSeleccionada' onClick={handleMenuClick(3)} style={{ color: '#0582a9' }}>Bitacora</div>
                                                    : <div className='opc_menuSeleccionada' onClick={handleMenuClick(3)} style={{ color: '#282828' }}>Bitacora</div>
                                                }
                                            </>
                            }
                        </div>
                    </div>
                )
                :   <>
                        {/* <div className='opc_menu' onClick={handleMenuClick(1)} style={{ color: '#0582a9' }}>Pacientes</div> */}
                        {
                            isMostrarPacientes
                            ?
                                <>
                                    <div className='opc_menuSeleccionada' onClick={handleMenuClick(1)} style={{ color: '#0582a9' }}>Quirófano ({totalQuirofano})</div>
                                    <div className='opc_menu' onClick={handleMenuClick(4)} style={{ color: '#282828' }}>Recuperación ({totalRecuperacion})</div>
                                    <div className='opc_menu' onClick={handleMenuClick(3)} style={{ color: '#282828' }}>Bitacora</div>
                                </>
                            :
                                isMostrarRecuperacion
                                    ?
                                        <>
                                            <div className='opc_menu' onClick={handleMenuClick(1)} style={{ color: '#282828' }}>Quirófano ({totalQuirofano})</div>
                                            <div className='opc_menuSeleccionada' onClick={handleMenuClick(4)} style={{ color: '#0582a9' }}>Recuperación ({totalRecuperacion})</div>
                                            <div className='opc_menu' onClick={handleMenuClick(3)} style={{ color: '#282828' }}>Bitacora</div>
                                        </>
                                    :
                                        <>
                                            <div className='opc_menu' onClick={handleMenuClick(1)} style={{ color: '#282828' }}>Quirófano ({totalQuirofano})</div>
                                            <div className='opc_menu' onClick={handleMenuClick(4)} style={{ color: '#0582a9' }}>Recuperación ({totalRecuperacion})</div>
                                            <div className='opc_menuSeleccionada' onClick={handleMenuClick(3)} style={{ color: '#282828' }}>Bitacora</div>
                                        </>
                        }
                    </>
            }
            </div>
        </>
    )
}

export default UserTop;